import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type UploadAnalyticsCommonParams, type UploadAnalyticsFailedStage } from './uploadAnalyticsTypes';
import META from './useTrackUploadAborted.meta';

export type UseTrackUploadAbortedParams = UploadAnalyticsCommonParams & {
  upload_duration_ms?: number;
  failed_stage: UploadAnalyticsFailedStage;
};

export const useTrackUploadAborted = () => {
  const { track } = useAnalyticsUtilities();

  const trackUploadAborted = useCallback(
    (params: UseTrackUploadAbortedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackUploadAborted };
};
